import React from "react"

import { Canvas } from "./styles"

import { BlobAnimation } from "./Animation"

class BlobCompo extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}

    this.canvasRef = React.createRef()
  }

  update = () => {
    const gradient =
      this.props.blobColors &&
      this.props.blobColors[0] &&
      this.props.blobColors[1]
        ? {
            ...this.props.gradient,
            c1: this.props.blobColors[0],
            c2: this.props.blobColors[1],
          }
        : this.props.gradient

    new BlobAnimation({
      canvas: this.canvasRef.current,

      position: this.props.position,

      gradient: gradient,

      strength: this.props.strength,

      padding: this.props.padding,

      points: this.props.points,

      size: this.props.size,

      smoothRatioResize: this.props.smoothRatioResize,
    })
  }

  componentDidUpdate() {
    this.update()
  }

  componentDidMount() {
    this.update()
  }

  render() {
    const { mobileOff } = this.props

    return <Canvas ref={this.canvasRef} mobileOff={mobileOff} />
  }
}

export default BlobCompo
